// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2H22V4H21V20H22V22H2V20H3V4H2V2ZM5 4V20H6.99914L7 4.00031L5 4ZM17 4V20H19V4H17ZM15 20V15C15 13.3431 13.6569 12 12 12C10.3431 12 9 13.3431 9 15V20H15Z"}}]};

const Dam5FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'dam-5-filled',
    ref,
    icon: element,
  },
));

Dam5FilledIcon.displayName = 'Dam5FilledIcon';

export default Dam5FilledIcon;
